const base = 'https://mastery.invalid';
export function safeReturnTo(value: string | null | undefined, fallback = '/') {
  if (
    !value ||
    !value.startsWith('/') ||
    value.startsWith('//') ||
    value.length > 2048 ||
    /[\u0000-\u0020\\]/.test(value)
  )
    return fallback;
  try {
    const url = new URL(value, base);
    const decoded = decodeURIComponent(url.pathname);
    if (
      url.origin !== base ||
      decoded.startsWith('//') ||
      /[\u0000-\u001f\\]/.test(decoded) ||
      /^\/(login|register|forgot-password|reset-password|confirm-email)\/?$/.test(decoded)
    )
      return fallback;
    return url.pathname + url.search + url.hash;
  } catch {
    return fallback;
  }
}
export function authURL(mode: 'login' | 'register', returnTo = '/', referral = '') {
  const params = new URLSearchParams();
  const target = safeReturnTo(returnTo);
  if (target !== '/') params.set('returnTo', target);
  if (referral) params.set('ref', referral);
  return '/' + mode + (params.size ? '?' + params : '');
}
export function rememberReferral(search: string) {
  const referral = new URLSearchParams(search).get('ref');
  if (referral && /^[a-zA-Z0-9_-]{1,64}$/.test(referral)) {
    try {
      sessionStorage.setItem('mastery:referral', referral);
    } catch {}
  }
}
export function referralCode() {
  const direct = new URLSearchParams(window.location.search).get('ref');
  if (direct && /^[a-zA-Z0-9_-]{1,64}$/.test(direct)) return direct;
  try {
    return sessionStorage.getItem('mastery:referral') ?? '';
  } catch {
    return '';
  }
}
